import namespace from '@/store/namespace'
export default namespace('Dominios',{
    getters:[
        'GetHorarioAtencion'
    ],
    actions:[
        'ObtienerDominios',
        'ObtienerCriterioDominios',
        'ObtenerHorarioAtencion'
    ],
    mutations:[
        'SetHorarioAtencion'
    ]
})
